export const meta = {
  title: "Der ultimative Pack-Guide für die Schweiz (Alle Jahreszeiten)",
  description: "Was gehört in den Koffer für Ihren Urlaub in den Schweizer Alpen? Eine vollständige Checkliste für Sommerwanderungen, Wintersport und Spa-Entspannung in Beatenberg.",
  date: "2024-03-10",
  image: "/images/local_attractions/alpine_hiking_trails.webp",
  author: "Beatenberg Concierge",
  category: "Travel Planning",
  keywords: ["Packliste Schweiz", "Kleidung Schweizer Alpen Sommer", "Winter Packliste Schweiz", "Schweiz Reise Checkliste"]
}

# Der ultimative Pack-Guide für die Schweiz

Das Packen für die Schweizer Alpen kann knifflig sein. Das Wetter in den Bergen kann sich in Minuten ändern.

<JournalQuote>
  "Es gibt kein schlechtes Wetter, nur schlechte Kleidung." — Schweizer Sprichwort
</JournalQuote>

## Die goldene Regel: Zwiebelprinzip
Das Geheimnis für Komfort in den Alpen ist das Zwiebelprinzip.

*Inhalt wird bald erweitert...*
